<!--我的资料弹框-->
<template>
  <div class="mine-container">
    <van-dialog v-model="mineInfoShow" :show-confirm-button="false" :width="isPc ? '7.36rem' : '3.36rem'">
      <template #default>
        <div class="mine-container-p">
          <div class="title">{{ content.mineInfo }}</div>
          <div v-if="canClose" class="close-icon" @click="closeDialog"><van-icon name="cross" size="0.23rem" /></div>
          <el-form class="maxHeight70 form-p beauty-scroll">
            <el-form-item :label="content.loginNameLabel">
              <el-input v-model="perfectForm.name" :maxlength="15" :placeholder="content.loginNameTip"> </el-input>
            </el-form-item>
            <el-form-item :label="content.selectSexLabel">
              <el-select v-model="perfectForm.sex" :placeholder="content.selectSex">
                <el-option v-for="item in sexColumns" :key="item.code" :label="item.name" :value="item.code"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="content.selectBirthdayLabel">
              <el-date-picker v-model="perfectForm.birthday" type="date" :placeholder="content.selectBirthday"> </el-date-picker>
            </el-form-item>
            <el-form-item v-if="lanuage == 'Chinese'" :label="content.selectTypeLabel">
              <el-select v-model="perfectForm.code" :placeholder="content.selectType" @change="pcTypeChange">
                <el-option v-for="item in columns" :key="item.code" :label="item.name" :value="item.code"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type) && lanuage == 'Chinese'"
              :label="content.selectHospitalLabel"
            >
              <el-select
                v-model="perfectForm.hospital_name"
                filterable
                allow-create
                remote
                clearable
                :placeholder="content.selectHospital"
                :loading="pcHospitalLoading"
                :remote-method="pcHospitalRemoteMethod"
                @clear="pcHospitalClear"
                @focus="pcHospitalFocus"
              >
                <el-option v-for="item in pcHospitalColumns" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="lanuage != 'Chinese'" :label="content.loginCompanyLabel">
              <el-input v-model="perfectForm.hospital_name" :placeholder="content.loginCompanyTip"> </el-input>
            </el-form-item>
            <el-form-item
              v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type) && lanuage == 'Chinese'"
              :label="content.selectOfficeLabel"
            >
              <el-cascader
                v-model="officesFormData"
                :options="officesList"
                :placeholder="content.selectOffice"
                :show-all-levels="false"
                @change="selectOfficeChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item v-if="lanuage != 'Chinese'" :label="content.loginOfficeLabel">
              <el-input v-model="perfectForm.hospital_offices" :placeholder="content.loginOfficeTip"> </el-input>
            </el-form-item>
            <el-form-item
              v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type) && lanuage == 'Chinese'"
              :label="content.selectJobTitleLabel"
            >
              <el-select v-model="perfectForm.job_title" :placeholder="content.selectJobTitle">
                <el-option v-for="item in jobTitleList" :key="item.id" :label="item.job_title" :value="item.job_title"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="['医学生'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectSchoolLabel">
              <el-select
                v-model="perfectForm.school"
                filterable
                remote
                clearable
                :placeholder="content.selectSchool"
                :loading="pcSchoolLoading"
                :remote-method="pcSchoolRemoteMethod"
                @clear="pcSchoolClear"
                @focus="pcSchoolFocus"
              >
                <el-option v-for="item in pcSchoolColumns" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="['医学生'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectSpecialtyLabel">
              <el-input v-model="perfectForm.specialty" :maxlength="15" :placeholder="content.selectSpecialty"> </el-input>
            </el-form-item>
            <el-form-item v-if="['医学生'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectEducationLabel">
              <el-select v-model="perfectForm.education" :placeholder="content.selectEducation">
                <el-option v-for="item in educationList" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="['其他医务从业者', '非医务从业者'].includes(perfectForm.type) && lanuage == 'Chinese'"
              :label="content.selectUnitLabel"
            >
              <el-input v-model="perfectForm.work_unit" :maxlength="30" :placeholder="content.selectUnit"> </el-input>
            </el-form-item>
            <el-form-item
              v-if="['其他医务从业者', '非医务从业者'].includes(perfectForm.type) && lanuage == 'Chinese'"
              :label="content.selectPostLabel"
            >
              <el-input v-model="perfectForm.post" :maxlength="20" :placeholder="content.selectPost"> </el-input>
            </el-form-item>
            <el-form-item :label="content.shipAddressLabel">
              <el-input v-model="perfectForm.receiving_address" :maxlength="30" :placeholder="content.shipAddressTip"> </el-input>
            </el-form-item>
          </el-form>
          <van-button
            type="info"
            round
            class="perfectBtn"
            :disabled="!validForm"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="perfectBtn"
          >
            {{ content.submit }}
          </van-button>
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  postUserInfo,
  postUpdateMyInfo,
  postIdentityList,
  getAuthJobTitles,
  getAuthOffices,
  getHospitalRecommend,
  getSchoolRecommend,
  getAuthHospitals,
  getAuthSchools
} from '@/models/common'
import { debounce, parseTime } from '@/utils/index.js'
export default {
  props: {
    canClose: {
      // 是否允许关闭
      type: Boolean,
      default: false
    }
  },
  computed: {
    validForm: function() {
      if (this.lanuage == 'Chinese') {
        if (this.perfectForm.sex == '' || this.perfectForm.birthday == '') {
          return false
        }
        if (['医生', '护士', '医技', '药师'].includes(this.perfectForm.type)) {
          return (
            this.perfectForm.name?.trim() &&
            this.perfectForm.hospital_name?.trim() &&
            this.perfectForm.hospital_offices?.trim() &&
            this.perfectForm.job_title?.trim()
          )
        } else if (['医学生'].includes(this.perfectForm.type)) {
          return (
            this.perfectForm.name?.trim() && this.perfectForm.school?.trim() && this.perfectForm.specialty?.trim() && this.perfectForm.education?.trim()
          )
        } else if (['其他医务从业者', '非医务从业者'].includes(this.perfectForm.type)) {
          return this.perfectForm.name?.trim() && this.perfectForm.work_unit?.trim() && this.perfectForm.post?.trim()
        } else {
          return false
        }
      } else {
        // 非中文版只允许输入姓名、性别、生日、医院、科室
        return (
          this.perfectForm.name?.trim() &&
          this.perfectForm.sex != '' &&
          this.perfectForm.birthday != '' &&
          this.perfectForm.hospital_name?.trim() &&
          this.perfectForm.hospital_offices?.trim()
        )
      }
    },
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc'])
  },
  data() {
    return {
      memberId: '',
      mineInfoShow: false, // 完善弹框
      sexColumns: [
        { name: '男', code: '男' },
        { name: '女', code: '女' }
      ],
      perfectForm: {
        // 完善框表单
        type: '',
        code: 0,
        name: '',
        sex: '',
        birthday: '',
        hospital_name: '',
        hospital_offices: '',
        job_title: '',
        school: '',
        specialty: '',
        education: '',
        work_unit: '',
        post: '',
        receiving_address: '',
      },
      columns: [], //身份 1001：医生1002：护士1003：医技1004：药师1005：医学生1006：其他医务从业者1007：非医务从业者
      showHospitalPicker: false, // 医院选择器
      hospitalSearch: '', // 医院关键词
      hospitalList: [], // 医院列表
      hospitalRecommendList: [], // 推荐医院列表
      pcHospitalColumns: [], // pc端的下拉医院列表
      pcHospitalLoading: false, // 远程搜索的医院下拉框loading
      showOfficesPicker: false, // 科室选择器
      officesList: [], // 科室列表
      officesLastList: [], // 科室最后一级列表，用于协助级联框回显
      officesFormData: '', // pc端科室级联回显项
      showJobTitlePicker: false, // 职称选择器
      jobTitleList: [], // 职称列表
      showSchoolPicker: false, // 学校选择器
      schoolSearch: '', // 学校关键词
      schoolList: [], // 学校列表
      schoolRecommendList: [], // 推荐学校列表
      pcSchoolColumns: [], // pc端的下拉学校列表
      pcSchoolLoading: false, // 远程搜索的学校下拉框loading
      showEducationPicker: false, // 学历选择器
      educationList: ['博士', '硕士', '本科', '大专', '高中/中专'] // 学历列表
    }
  },
  // watch: { // 后续触发不了，临时改成在change中改变
  //   'perfectForm.code': {
  //     handler (val) {
  //       console.log(val);
  //       this.perfectForm.job_title = ''
  //       this.getJobTitles(val)
  //     },
  //     deep: true
  //   }
  // },
  mounted() {
    // 初始化身份列表
    postIdentityList().then((res) => {
      if (res.data.code == 0) {
        this.columns = res.data.data
        // console.log(res.data);
        this.perfectForm.type = this.columns[0].name
        this.perfectForm.code = this.columns[0].code
      }
    })
    if (this.isPc) {
      this.getOffices().then((data) => {
        let arr = data.map((v) => {
          return {
            label: v.title,
            value: v.id,
            children: []
          }
        })
        let lastLevelList = []
        for (let i = 0; i < arr.length; i++) {
          this.getOffices(data[i].id).then((data) => {
            arr[i].children = data.map((v) => {
              return {
                label: v.title,
                value: v.id
              }
            })
            lastLevelList.push(
              ...data.map((v) => {
                return {
                  parent_id: v.parent_id,
                  label: v.title,
                  value: v.id
                }
              })
            )
          })
        }
        this.officesList = arr
        this.officesLastList = lastLevelList
        if (this.officesLastList.length > 0 && this.perfectForm.hospital_offices) {
          let obj = this.officesLastList.filter((item) => {
            return item.label == this.perfectForm.hospital_offices
          })
          if (obj.length > 0) {
            this.officesFormData = [obj[0].parent_id, obj[0].id]
          }
        }
      })
    } else {
      // 初始化一级科室
      this.getOffices().then((data) => {
        this.officesList = [{ values: data }, { values: [] }]
        if (data.length > 0) {
          this.getOffices(data[0].id).then((data) => {
            this.officesList[1].values = data
          })
        }
      })
    }
    // 初始化医院推荐
    getHospitalRecommend().then((res) => {
      if (res.data.code == 0) {
        this.hospitalRecommendList = res.data.data
        if (this.isPc) {
          this.pcHospitalColumns = res.data.data.map((v) => v.hospital_name)
        }
      }
    })
    // 初始化学校推荐
    getSchoolRecommend().then((res) => {
      if (res.data.code == 0) {
        this.schoolRecommendList = res.data.data
        if (this.isPc) {
          this.pcSchoolColumns = res.data.data.map((v) => v.school)
        }
      }
    })
  },
  methods: {
    // pc-选择身份
    pcTypeChange(e) {
      const name = this.columns.filter((item) => {
        return item.code == e
      })[0].name
      this.$set(this.perfectForm, 'type', name)
      this.perfectForm.job_title = ''
      this.getJobTitles(e)
    },
    // pc-搜索医院
    pcHospitalRemoteMethod(query) {
      const _this = this
      if (query !== '') {
        this.pcHospitalLoading = true
        debounce(() => {
          getAuthHospitals({
            keyword: query
          }).then((res) => {
            if (res.data.code == 0) {
              _this.pcHospitalLoading = false
              _this.pcHospitalColumns = res.data.data.map((v) => v.name)
            }
          })
        }, 1000)()
      } else {
        this.pcHospitalLoading = false
        this.pcHospitalColumns = this.hospitalRecommendList.map((v) => v.hospital_name)
      }
    },
    // pc-医院下拉框在获取焦点时，如果没选值，则初始化推荐的医院
    pcHospitalFocus() {
      if (this.perfectForm.hospital_name == '') {
        this.pcHospitalColumns = this.hospitalRecommendList.map((v) => v.hospital_name)
      }
    },
    // pc-医院下拉框清空方法
    pcHospitalClear() {
      this.pcHospitalFocus()
    },
    // pc-所在科室的级联框变更
    selectOfficeChange(e) {
      if (this.officesLastList.length > 0) {
        let obj = this.officesLastList.filter((item) => {
          return item.value == e[1]
        })
        if (obj.length > 0) {
          this.perfectForm.hospital_offices = obj[0].label
        }
      }
    },
    // pc-搜索学校
    pcSchoolRemoteMethod(query) {
      const _this = this
      if (query !== '') {
        this.pcSchoolLoading = true
        debounce(() => {
          getAuthSchools({
            name: query
          }).then((res) => {
            if (res.data.code == 0) {
              _this.pcSchoolLoading = false
              _this.pcSchoolColumns = res.data.data.map((v) => v.name)
            }
          })
        }, 1000)()
      } else {
        this.pcSchoolLoading = false
        this.pcSchoolColumns = this.schoolRecommendList.map((v) => v.school)
      }
    },
    // pc-学校下拉框在获取焦点时，如果没选值，则初始化推荐的学校
    pcSchoolFocus() {
      if (this.perfectForm.school == '') {
        this.pcSchoolColumns = this.schoolRecommendList.map((v) => v.school)
      }
    },
    // pc-学校下拉框清空方法
    pcSchoolClear() {
      this.pcSchoolFocus()
    },
    // 关闭弹窗
    closeDialog() {
      this.mineInfoShow = false
    },
    // 完善资料弹窗
    showDialog() {
      this.getInfo()
      this.mineInfoShow = true
    },
    // 获取用户详情
    getInfo() {
      // 若地址不传则先取缓存的，没缓存则默认游客
      if (localStorage.getItem('loginItem')) {
        this.memberId = JSON.parse(localStorage.getItem('loginItem')).userId
      } else {
        this.memberId = '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9'
      }
      postUserInfo({
        member_id: this.memberId
      }).then((res) => {
        if (res.data.code == 0) {
          this.perfectForm = res.data.data
          this.perfectForm.code = res.data.data.type
          this.perfectForm.sex = res.data.data.sex == 1 ? '男' : '女'
          switch (res.data.data.type) {
            case 1001:
              this.perfectForm.type = '医生'
              break
            case 1002:
              this.perfectForm.type = '护士'
              break
            case 1003:
              this.perfectForm.type = '医技'
              break
            case 1004:
              this.perfectForm.type = '药师'
              break
            case 1005:
              this.perfectForm.type = '医学生'
              break
            case 1006:
              this.perfectForm.type = '其他医务从业者'
              break
            case 1007:
              this.perfectForm.type = '非医务从业者'
              break
            default:
              break
          }
          if(this.perfectForm.code) {
            this.getJobTitles(this.perfectForm.code)
          }
          if (res.data.data.birthday) {
            this.selectBirthDay = new Date(res.data.data.birthday.replaceAll('-', '/'))
          }
          if (this.officesLastList.length > 0 && this.perfectForm.hospital_offices) {
            let obj = this.officesLastList.filter((item) => {
              return item.label == this.perfectForm.hospital_offices
            })
            if (obj.length > 0) {
              this.officesFormData = [obj[0].parent_id, obj[0].value]
            }
          }
        }
      })
    },
    // 获取职称列表
    getJobTitles(code) {
      getAuthJobTitles({
        identity_no: code
      }).then((res) => {
        if (res.data.code == 0) {
          this.jobTitleList = res.data.data
        }
      })
    },
    // 获取科室列表
    getOffices(pId = 0) {
      // console.log('获取科室列表--','pcMine')
      return new Promise((resolve, reject) => {
        getAuthOffices({
          parent_id: pId
        }).then((res) => {
          if (res.data.code == 0) {
            resolve(res.data.data)
          } else {
            reject(res.data.data)
          }
        })
      })
    },
    // 完善资料页按钮
    perfectBtn() {
      const _this = this
      const form = {
        member: {
          name: this.perfectForm.name,
          hospital_name: this.perfectForm.hospital_name,
          hospital_offices: this.perfectForm.hospital_offices,
          job_title: this.perfectForm.job_title,
          school: this.perfectForm.school,
          specialty: this.perfectForm.specialty,
          education: this.perfectForm.education,
          work_unit: this.perfectForm.work_unit,
          post: this.perfectForm.post,
          sex: this.perfectForm.sex == '男' ? 1 : 2,
          birthday: parseTime(this.perfectForm.birthday, '{y}-{m}-{d}')
        },
        member_id: this.perfectForm.id,
        receiving_address: this.perfectForm.receiving_address,
      }
      switch (this.perfectForm.type) {
        case '医生':
          form.type = 1001
          break
        case '护士':
          form.type = 1002
          break
        case '医技':
          form.type = 1003
          break
        case '药师':
          form.type = 1004
          break
        case '医学生':
          form.type = 1005
          break
        case '其他医务从业者':
          form.type = 1006
          break
        case '非医务从业者':
          form.type = 1007
          break
        default:
          break
      }
      postUpdateMyInfo(form).then((res) => {
        if (res.data.code == 0) {
          _this.$toast(_this.content.saveSuccess)
          _this.mineInfoShow = false
          this.resetForm()
          this.$emit('editSuccess')
        } else {
          _this.$toast(_this.content.saveFail)
          this.$emit('perfectFail')
        }
      })
    },
    // 重置
    resetForm() {
      this.perfectForm = {
        // 完善框表单
        type: this.columns[0].name,
        code: this.columns[0].code,
        name: '',
        sex: '',
        birthday: '',
        hospital_name: '',
        hospital_offices: '',
        job_title: '',
        school: '',
        specialty: '',
        education: '',
        work_unit: '',
        post: ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.van-dialog {
  border-radius: 6px;
}
.mine-container {
  .mine-container-p {
    padding: 0 0.35rem;
    .form-p{
      padding: 0 0.4rem;
    }
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    .el-cascader {
      width: 100%;
    }
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.2rem;
      margin-bottom: 0.1rem;
    }
    .close-icon {
      position: absolute;
      top: 0.33rem;
      right: 0.3rem;
      cursor: pointer;
    }
    .van-cell {
      // margin-top: 0.1rem;
      padding: 0.13333rem 0;
    }
    .perfect-tip {
      color: #c0c4cc;
      font-size: 0.18rem;
    }
    .perfectBtn {
      width: 2.8rem;
      height: 0.55rem;
      margin: 0.25rem auto 0.25rem;
      display: block;
    }
  }
}
</style>
